module.exports = __webpack_public_path__ + "static/media/car_racing.06b09f14.gif";